import React, { createContext, useContext, useRef } from 'react'

interface BuilderSession {
  count: number
  selected: number | null
  hasCreatedSubtask: boolean
  hasStartedBuilding?: boolean
}
const SessionContext = createContext<React.MutableRefObject<BuilderSession | null> | null>(null)

/** UI-only state survives settings and the VM AI sub-flow; never included in a task payload. */

export const BuilderSessionProvider: React.FC = ({ children }) => {
  const session = useRef<BuilderSession | null>(null)

  return <SessionContext.Provider value={session}>{children}</SessionContext.Provider>
}

export const useBuilderSession = () => useContext(SessionContext)
